import { Statistics } from 'src/api';
import StatPointList = Statistics.Types.StatPointList;
import StatCountValue = Statistics.Types.StatCountValue;
import PendingPostings = Statistics.Types.PendingPostings;

export interface StatisticsStateInterface {
  pendingPostings: PendingPostings;
  validationFailures: StatPointList;
  deliveredPostings: StatPointList;
  validationSuccess: StatPointList;
  deliveredNewPostings: StatPointList;
  deliveryFailures: StatCountValue;
  inProcessPostings: StatPointList;
  period: string;
  loading: {
    inProcess: boolean;
    validation: boolean;
    delivery: boolean;
  };
}

export default function (): StatisticsStateInterface {
  return {
    pendingPostings: { url: '', count: 0 },
    validationFailures: [],
    deliveredPostings: [],
    validationSuccess: [],
    deliveredNewPostings: [],
    deliveryFailures: {
      count: 0,
    },
    inProcessPostings: [],
    period: Statistics.PERIODS.DAY.value,
    loading: {
      inProcess: true,
      validation: true,
      delivery: true,
    },
  };
}
